"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.IconExpandMore = function (_a) {
    var color = _a.color, style = _a.style;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 155.948", style: style },
        React.createElement("path", { fill: color, d: "M127.99 155.95L0 27.96 27.96 0l100.03 100.03L228.04 0 256 27.96 127.99 155.95z" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/IconExpandMore.tsx
// module id = 306
// module chunks = 0